import React, { useState } from "react";
import { motion } from "framer-motion";

const Experience = () => {
  const [resumeUrl, setResumeUrl] = useState(
    "https://drive.google.com/file/d/1t_y85q0pUV3UmuETLrD4ORcWGQFT5GMN/view?usp=drive_link"
  );
  return (
    <div className="experience-container">
      <motion.div
        className="aboutHeading experience-title"
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1, delay: 0.3 }}>
        Experience
      </motion.div>
      <div className="experience-content">
        <div className="experience-card">
          <div className="company-name">Zeal Global Inc</div>
          <div className="position-duration">
            <span className="position">
              <u>Frontend Intern</u>
              <a
                className="recommendation-letter-link"
                href="https://drive.google.com/file/d/1E5zblZmWZmVgqJTkE4_sXSUjsDz5C-BF/view?usp=drive_link">
                Letter
              </a>
            </span>
            <span>july-2024 -- August-2024</span>
          </div>
          <div className="working-details">
            <ul>
              <li>
                Implemented a page break feature, enhancing UI responsiveness
                across devices.
              </li>
              <li>
                Developed a PDF export feature with 95% UI replication accuracy,
                improving document formatting.
              </li>
              <li>Tools & Technologies used: JavaScript, HTML, CSS</li>
            </ul>
          </div>
        </div>
      </div>
      <div></div>
    </div>
  );
};

export default Experience;
